import {InjectionToken} from "@angular/core";

export const LOGGER = new InjectionToken("LOGGER");
export interface Logger {
  debug(msg: Record<string | number, Record<string | number, any>>): void;
  info(msg: Record<string | number, any>): void;
  warn(msg: Record<string | number, any>): void;
  error(msg: Record<string | number, any>): void;
}
